"use client";

import React, { useState, useEffect } from "react";

import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";
import EnableTwoFA from "./EnableTwoFA";
import { useAuth } from "../context/AuthContext";
import TwoFA from "./MainTwoFA";
import withOverlay from "../hoc/withOverlay";
import { SecuredFooter } from "./ui/secured-footer";
import CurrencyFormatter from "../utils/currencyFormatter";

const TwoFAOverlay = withOverlay(TwoFA);
export default function WithdrawConfirm({
  data,
  bank,
  onBack,
  onConfirm,
  quoteData,
  setUp,
  instantPayment,
  originalAmount,
}) {
  const [isConfirmed, setIsComfirmed] = useState(false);
  const [open, setOpen] = useState(false);
  const [isTwoFAOpen, setIsTwoFAOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);

  const { settings } = useAuth();
  const formatter = new CurrencyFormatter();

  const withdrawalFee = instantPayment ? 60 : 0;
  const amountReceived = originalAmount
    ? Math.max(0, originalAmount - withdrawalFee)
    : quoteData?.amountReceived || 0;
  const totalCost = originalAmount || quoteData?.totalAmount || 0;

  const withdrawalFeeFormatted = formatter.format(withdrawalFee, "ZAR");
  const amountReceivedFormatted = formatter.format(amountReceived, "ZAR");
  const totalCostFormatted = formatter.format(totalCost, "ZAR");

  useEffect(() => {
    if (settings) setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);

  const handleConfirm = () => {
    setIsComfirmed(true);
    if (!isEnabled) {
      setOpen(true);
    }
    if (isEnabled) {
      onConfirm();
    }
  };

  const handleSetUp = () => {
    if (setUp) {
      setUp();
    }
  };

  const handleLocalBack = () => {
    setIsComfirmed(false);
    if (onBack) {
      onBack();
    }
  };
  const handleCloseOverlay = () => {
    setIsTwoFAOpen(false);
    setIsComfirmed(false);
  };
  const handleClose = () => {
    setIsComfirmed(false);
  };
  return (
    <Card className="w-full !shadow-none bg-white rounded-2xl">
      <div className="px-6 pt-8">
        <div className="flex items-center justify-center text-center py-5 bg-gray-100 rounded-lg px-6 pt-8">
          <h2 className="text-[32px] font-semibold text-[#33125F]">
            {amountReceivedFormatted}
          </h2>
        </div>

        <CardContent className="px-6 mt-6">
          <h3 className="text-[20px] font-semibold text-[#33125F] mb-3">
            Transaction details
          </h3>

          <div className="border rounded-lg divide-y">
            <div className="p-4 flex justify-between">
              <span className="text-[14px] font-normal text-[#423E51]">
                You Withdraw
              </span>
              <span className="text-[14px] font-semibold text-[#33125F]">
                {amountReceivedFormatted}
              </span>
            </div>
            <div className="p-4 flex justify-between">
              <span className="text-[14px] font-normal text-[#423E51]">
                Withdraw from
              </span>
              <span className="text-[14px] font-semibold text-[#33125F]">
                Digital Wallet
              </span>
            </div>
            <div className="p-4 flex justify-between">
              <span className="text-[14px] font-normal text-[#423E51]">
                Withdraw to
              </span>
              <span className="text-[14px] font-semibold text-[#33125F]">
                {bank?.bankName ?? bank?.bank}
                <p className="text-[12px] font-normal text-[#6D6584]">
                  Acc no: {bank?.accNumber ?? bank?.accountNumber ?? "—"}
                </p>
              </span>
            </div>

            <div className="p-4 flex justify-between">
              <span className="text-[14px] font-normal text-[#423E51]">
                Withdrawal Fee
              </span>
              <span className="text-[14px] font-semibold text-[#33125F]">
                {withdrawalFeeFormatted}
              </span>
            </div>

            <div className="p-4 flex justify-between">
              <span className="text-[14px] font-normal text-[#423E51]">
                Total cost
              </span>
              <span className="text-[14px] font-semibold text-[#33125F]">
                {totalCostFormatted}
              </span>
            </div>
          </div>
        </CardContent>

        <div className="flex items-center justify-center w-full mt-6">
          <div className="px-6 py-6">
            <Button
              variant="ghost"
              onClick={handleLocalBack}
              className="w-10 h-10 rounded-full p-0 border border-gray-200 hover:bg-gray-100"
            >
              <ArrowLeft size={20} className="text-[#33125F]" />
            </Button>
          </div>

          <Button
            onClick={handleConfirm}
            disabled={isConfirmed}
            className="px-6 py-4 rounded-full font-semibold transition-opacity w-full md:min-w-[302px] max-w-sm h-[48px] text-sm sm:text-base bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:opacity-90"
          >
            Confirm
          </Button>
        </div>
      </div>
      <EnableTwoFA
        open={open}
        setOpen={setOpen}
        setIsTwoFAOpen={setIsTwoFAOpen}
        onClose={handleClose}
      />

      <SecuredFooter className="mt-6" />
      <TwoFAOverlay
        isOpen={isTwoFAOpen}
        closeOverlay={handleCloseOverlay}
        isSetUp={handleSetUp}
      />
    </Card>
  );
}
